module.exports = __webpack_public_path__ + "img/test11_big.30e69219.jpg";